import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NbRequestRequest } from '@compiere-ws/models/apiz-domains';
import { CompiereDataGridResponseJSON } from '@compiere-ws/models/compiere-data-json';
import { AppConfig } from '@iupics-config/app.config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  #http = inject(HttpClient);
  #config = inject(AppConfig);

  #url: string | undefined;
  get url(): string {
    if (this.#url === undefined) {
      this.#url = this.#config.getBackendResource('nbRequests');
    }
    return this.#url;
  }

  getNbRequests(request: NbRequestRequest): Observable<CompiereDataGridResponseJSON> {
    return this.#http.post<CompiereDataGridResponseJSON>(this.url, request);
  }
}
